import { render, staticRenderFns } from "./ReportingStatements.vue?vue&type=template&id=061dce08&"
import script from "./ReportingStatements.vue?vue&type=script&lang=js&"
export * from "./ReportingStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061dce08')) {
      api.createRecord('061dce08', component.options)
    } else {
      api.reload('061dce08', component.options)
    }
    module.hot.accept("./ReportingStatements.vue?vue&type=template&id=061dce08&", function () {
      api.rerender('061dce08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/ReportingStatements.vue"
export default component.exports